import { types } from './actions.js';

const initialState = {
  currentUniverse: null,
  universes: [],
  loading: false,
  loader: true,
  endLoading: false,
}

export default function reducer(state = initialState, action) {
  if (action.type === types.SET_CURRENT_UNIVERSE) {
    return {
      ...state,
      currentUniverse: action.universe
    };
  } else if (action.type === types.SET_UNIVERSES) {
    return {
      ...state,
      universes: action.universes
    }
  } else if (action.type === types.START_LOADING) {
    return {
      ...state,
      loading: true
    };
  } else if (action.type === types.STOP_LOADING) {
    return {
      ...state,
      loading: false,
      endLoading: true,
    };
  } else if(action.type === types.CANCEL_LOADER) {
    return {
      ...state,
      loader: false,
    }
  }
  return state;
}